var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	5724: {
		fallback: function() { return function() { return __webpack_require__(5723); }; },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: true,
		eager: true,
		layer: undefined,
		shareKey: "react/jsx-runtime",
	},
	8443: {
		fallback: function() { return Promise.all([__webpack_require__.e(3777), __webpack_require__.e(4864), __webpack_require__.e(9505), __webpack_require__.e(5724), __webpack_require__.e(3517), __webpack_require__.e(2732)]).then(function() { return function() { return __webpack_require__(281); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/router",
	},
	122: {
		fallback: function() { return __webpack_require__.e(269).then(function() { return function() { return __webpack_require__(2650); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/head",
	},
	7402: {
		fallback: function() { return Promise.all([__webpack_require__.e(3777), __webpack_require__.e(556)]).then(function() { return function() { return __webpack_require__(556); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/link",
	},
	8732: {
		fallback: function() { return Promise.all([__webpack_require__.e(4864), __webpack_require__.e(3517), __webpack_require__.e(8823)]).then(function() { return function() { return __webpack_require__(4379); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/script",
	},
	3948: {
		fallback: function() { return Promise.all([__webpack_require__.e(1279), __webpack_require__.e(3517), __webpack_require__.e(1612)]).then(function() { return function() { return __webpack_require__(1279); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/image",
	},
	7884: {
		fallback: function() { return __webpack_require__.e(7461).then(function() { return function() { return __webpack_require__(2223); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/dynamic",
	},
	9065: {
		fallback: function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__(2155); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",
	},
	661: {
		fallback: function() { return __webpack_require__.e(1481).then(function() { return function() { return __webpack_require__(1481); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.1.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "styled-jsx",
	},
	7876: {
		fallback: function() { return __webpack_require__.e(9644).then(function() { return function() { return __webpack_require__(9644); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.1.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "styled-jsx/style",
	},
	3134: {
		fallback: function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__(8997); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom/client",
	},
	3517: {
		fallback: function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__(316); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom",
	},
	1137: {
		fallback: function() { return __webpack_require__.e(4604).then(function() { return function() { return __webpack_require__(2223); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "14.2.16",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/dynamic",
	},
	7743: {
		fallback: function() { return Promise.all([__webpack_require__.e(3777), __webpack_require__.e(556), __webpack_require__.e(807)]).then(function() { return function() { return __webpack_require__(556); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "14.2.16",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/link",
	},
	5279: {
		fallback: function() { return __webpack_require__.e(269).then(function() { return function() { return __webpack_require__(2650); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "14.2.16",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/head",
	},
	2089: {
		fallback: function() { return __webpack_require__.e(1279).then(function() { return function() { return __webpack_require__(1279); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "14.2.16",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/image",
	}
};
var moduleToHandlerMapping = {};
__webpack_require__.consumesLoadingData.initialConsumes = [5724,8443,122,7402,8732,3948,7884,9065,661,7876,5724,9065,3134,3517,5279,8443,2089,1137,7743];
__webpack_require__.federation.installInitialConsumes = function() { return __webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: __webpack_require__.consumesLoadingData.initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping,
	webpackRequire: __webpack_require__
}); }
__webpack_require__.consumesLoadingData.chunkMapping = {
	"636": [
		5279,
		8443,
		2089,
		1137,
		7743
	],
	"1137": [
		1137
	],
	"2288": [
		7743
	],
	"3517": [
		3517
	],
	"5527": [
		122,
		7402,
		8732,
		3948,
		7884,
		9065,
		661,
		7876
	],
	"5724": [
		5724
	],
	"8443": [
		8443
	],
	"8792": [
		5724,
		9065,
		3134,
		3517
	]
};
__webpack_require__.f.consumes = function(chunkId, promises) {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}